import {
  ADD_DOCUMENT,
  ADD_DOCUMENT_FAILED,
  ADD_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_FAILED,
  DELETE_DOCUMENT_SUCCESS,
  GET_DOCUMENT,
  GET_DOCUMENTS_SETUP,
  GET_DOCUMENTS_SETUP_FAILED,
  GET_DOCUMENTS_SETUP_SUCCESS,
  GET_DOCUMENT_FAILED,
  GET_DOCUMENT_LIST,
  GET_DOCUMENT_LIST_FAILED,
  GET_DOCUMENT_LIST_SUCCESS,
  GET_DOCUMENT_SUCCESS,
  HIDE_DELETE_DOCUMENT_MODAL,
  OPEN_DELETE_DOCUMENT_MODAL,
  RESET_DOCUMENT,
  RESET_DOCUMENT_LIST,
  UPDATE_DOCUMENT,
  UPDATE_DOCUMENTS_SETUP,
  UPDATE_DOCUMENTS_SETUP_FAILED,
  UPDATE_DOCUMENTS_SETUP_SUCCESS,
  UPDATE_DOCUMENT_FAILED,
  UPDATE_DOCUMENT_ORDER,
  UPDATE_DOCUMENT_ORDER_FAILED,
  UPDATE_DOCUMENT_ORDER_SUCCESS,
  UPDATE_DOCUMENT_STATUS,
  UPDATE_DOCUMENT_STATUS_FAILED,
  UPDATE_DOCUMENT_STATUS_SUCCESS,
  UPDATE_DOCUMENT_SUCCESS,
} from "./actionTypes"

export const addDocument = params => ({
  type: ADD_DOCUMENT,
  payload: params,
})

export const addDocumentSuccess = response => ({
  type: ADD_DOCUMENT_SUCCESS,
  payload: response,
})

export const addDocumentFailed = error => ({
  type: ADD_DOCUMENT_FAILED,
  payload: error,
})

export const getDocumentList = params => ({
  type: GET_DOCUMENT_LIST,
  payload: { params },
})

export const getDocumentListSuccess = response => ({
  type: GET_DOCUMENT_LIST_SUCCESS,
  payload: response,
})

export const getDocumentListFailed = error => ({
  type: GET_DOCUMENT_LIST_FAILED,
  payload: error,
})

export const resetDocumentList = params => ({
  type: RESET_DOCUMENT_LIST,
  payload: params,
})

export const getDocument = params => ({
  type: GET_DOCUMENT,
  payload: params,
})

export const getDocumentSuccess = response => ({
  type: GET_DOCUMENT_SUCCESS,
  payload: response,
})

export const getDocumentFailed = error => ({
  type: GET_DOCUMENT_FAILED,
  payload: error,
})

export const updateDocumentOrder = (featureId, menuItemId, params) => ({
  type: UPDATE_DOCUMENT_ORDER,
  payload: { featureId, menuItemId, params },
})

export const updateDocumentOrderSuccess = response => ({
  type: UPDATE_DOCUMENT_ORDER_SUCCESS,
  payload: response,
})

export const updateDocumentOrderFailed = error => ({
  type: UPDATE_DOCUMENT_ORDER_FAILED,
  payload: error,
})

export const updateDocumentStatus = (featureId, menuItemId, params) => ({
  type: UPDATE_DOCUMENT_STATUS,
  payload: { featureId, menuItemId, params },
})

export const updateDocumentStatusSuccess = response => ({
  type: UPDATE_DOCUMENT_STATUS_SUCCESS,
  payload: response,
})

export const updateDocumentStatusFailed = error => ({
  type: UPDATE_DOCUMENT_STATUS_FAILED,
  payload: error,
})

export const resetDocument = () => ({
  type: RESET_DOCUMENT,
  payload: {},
})

export const deleteDocument = (featureId, menuItemId) => ({
  type: DELETE_DOCUMENT,
  payload: { featureId, menuItemId },
})

export const deleteDocumentSuccess = response => ({
  type: DELETE_DOCUMENT_SUCCESS,
  payload: response,
})

export const deleteDocumentFailed = error => ({
  type: DELETE_DOCUMENT_FAILED,
  payload: error,
})

export const openDeleteDocumentModal = () => ({
  type: OPEN_DELETE_DOCUMENT_MODAL,
  payload: {},
})

export const hideDeleteDocumentModal = () => ({
  type: HIDE_DELETE_DOCUMENT_MODAL,
  payload: {},
})

export const updateDocument = (featureId, menuItemId, params) => ({
  type: UPDATE_DOCUMENT,
  payload: { featureId, menuItemId, params },
})

export const updateDocumentSuccess = response => ({
  type: UPDATE_DOCUMENT_SUCCESS,
  payload: response,
})

export const updateDocumentFailed = error => ({
  type: UPDATE_DOCUMENT_FAILED,
  payload: error,
})

export const getDocumentsSetup = params => ({
  type: GET_DOCUMENTS_SETUP,
  payload: params,
})

export const getDocumentsSetupSuccess = response => ({
  type: GET_DOCUMENTS_SETUP_SUCCESS,
  payload: response,
})

export const getDocumentsSetupFailed = error => ({
  type: GET_DOCUMENTS_SETUP_FAILED,
  payload: error,
})

export const updateDocumentsSetup = params => ({
  type: UPDATE_DOCUMENTS_SETUP,
  payload: params,
})

export const updateDocumentsSetupSuccess = response => ({
  type: UPDATE_DOCUMENTS_SETUP_SUCCESS,
  payload: response,
})

export const updateDocumentsSetupFailed = error => ({
  type: UPDATE_DOCUMENTS_SETUP_FAILED,
  payload: error,
})
